const styles = theme => ({
  content: {
    display: 'flex',
    padding: '0px 24px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '56px',
    alignSelf: 'stretch',
    borderBottom: '1px solid #F4F6F8',
    position: 'fixed',
    width: '100%',
    zIndex: '1100',
    background: '#ffffff !important',
    boxShadow: '0px 2px 8px 0px rgba(145, 158, 171, 0.12)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  closeButton: {
    display: 'flex',
    padding: '12px 8px',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
  },
  buttonDiv: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  icon: {
    width: 20,
    height: 20,
    padding: 1,
    cursor: 'pointer',
  },
})

export default styles
